import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'typewriter',
  pure: false // Пайп будет не чистым, чтобы иметь возможность динамически обновляться
})
export class TypewriterPipe implements PipeTransform {
  private currentIndex = 0;
  private displayedText = '';
  private timeoutId: any;

  transform(value: string, speed: number = 100): string {
    if (this.currentIndex < value.length) {
      if (!this.timeoutId) {
        this.timeoutId = setTimeout(() => {
          if (value[this.currentIndex] === '<') {
            // Находим конец тега и добавляем его сразу целиком
            const endTagIndex = value.indexOf('>', this.currentIndex);
            if (endTagIndex !== -1) {
              this.displayedText += value.slice(this.currentIndex, endTagIndex + 1);
              this.currentIndex = endTagIndex + 1;
            } else {
              this.displayedText += value[this.currentIndex];
              this.currentIndex++;
            }
          } else {
            this.displayedText += value[this.currentIndex];
            this.currentIndex++;
          }
          this.timeoutId = null; // Сброс таймера для следующего вызова
        }, speed);
      }
    }

    return this.displayedText;
  }
}
